import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomerNameComponent} from './customer-name.component';
import {NavigationToModule} from '../../shared/navigation-to/navigation-to.module';
import {I18nModule, UrlModule} from '@spartacus/core';
import {InputModule} from 'ng-design-system';
import {ReactiveFormsModule} from '@angular/forms';
import {LoadingIndicatorComponent} from '@dcp/configurator';

@NgModule({
  declarations: [CustomerNameComponent],
  imports: [
    CommonModule,
    NavigationToModule,
    I18nModule,
    InputModule,
    ReactiveFormsModule,
    UrlModule,
    LoadingIndicatorComponent
  ],
  exports: [CustomerNameComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class CustomerNameModule {
}
